import React from 'react'
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

import { OrderType, TableHeadCellPropsType } from '@/state'

type Props<T> = {
  headCells: TableHeadCellPropsType<T>[]
  hasAction?: boolean
  order?: OrderType
  orderBy?: keyof T
  createSortHandler?: (
    property: keyof T,
  ) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const TableHeadGenericComponent = <T extends { [key: string]: any }>({
  order,
  orderBy,
  createSortHandler,
  headCells,
  hasAction,
}: Props<T>) => {
  return (
    <TableHead>
      <TableRow>
        {headCells?.map(
          (item) =>
            item.visible !== false && (
              <TableCell
                key={item.id.toString()}
                sortDirection={
                  orderBy === (item.sortId || item.id) ? order || false : false
                }
                sx={{
                  width: item.width || 'auto',
                  minWidth: item.width || item.minWidth || 'auto',
                  position: item.sticky ? 'sticky' : 'auto',
                  zIndex: item.sticky ? 10 : 'auto',
                  boxShadow: item.sticky ? 6 : 0,
                  left: item.left || 0,
                }}
              >
                {item.sort && order && orderBy && createSortHandler ? (
                  <TableSortLabel
                    IconComponent={KeyboardArrowDown}
                    active={orderBy === (item.sortId || item.id)}
                    direction={order}
                    onClick={createSortHandler(item.sortId || item.id)}
                  >
                    {item.label}
                  </TableSortLabel>
                ) : (
                  item.label
                )}
              </TableCell>
            ),
        )}
        {hasAction && (
          <TableCell
            sx={{
              position: 'sticky',
              right: 0,
              width: 50,
            }}
          />
        )}
      </TableRow>
    </TableHead>
  )
}
